import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry
*/
import React, { useRef, useState, useEffect, useContext } from 'react';
import unique from '../../lib/unique-id/unique-id';
import AccordionControl from './support/AccordionControl';
import AccordionContent from './support/AccordionContent';
import AccordionContext from './AccordionContext';

var Accordion = function Accordion(_ref) {
  var _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? function () {
    return undefined;
  } : _ref$onToggle,
      _ref$onOpen = _ref.onOpen,
      onOpen = _ref$onOpen === void 0 ? function () {
    return undefined;
  } : _ref$onOpen,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return undefined;
  } : _ref$onClose,
      _ref$confirmOpen = _ref.confirmOpen,
      confirmOpen = _ref$confirmOpen === void 0 ? function () {
    return Promise.resolve();
  } : _ref$confirmOpen,
      _ref$confirmClose = _ref.confirmClose,
      confirmClose = _ref$confirmClose === void 0 ? function () {
    return Promise.resolve();
  } : _ref$confirmClose,
      children = _ref.children;
  var lastPropsOpen = useRef(open);

  var _useState = useState(open),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var parentId = useRef(unique());
  var childId = useRef(unique());

  var _useContext = useContext(AccordionContext),
      level = _useContext.level;

  useEffect(function () {
    if (open !== isOpen && open !== lastPropsOpen.current) {
      lastPropsOpen.current = open;
      setIsOpen(open);
    }
  }, [isOpen, open]);

  var toggle = function toggle() {
    var confirm = isOpen ? confirmClose : confirmOpen;
    confirm().then(function () {
      if (isOpen) {
        setIsOpen(false);
        onClose();
      } else {
        setIsOpen(true);
        onOpen();
      }

      onToggle(!isOpen);
    })["catch"](function () {
      return undefined;
    });
  };

  var clones = React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      open: isOpen,
      toggle: toggle,
      parentId: parentId.current,
      childId: childId.current
    });
  });
  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: {
      level: level + 1
    }
  }, /*#__PURE__*/React.createElement("div", null, clones));
};

Accordion.Control = AccordionControl;
Accordion.Content = AccordionContent;
export default Accordion;